<div class="header cor-master">
    <div class="title">Alterar senha</div>
    <button class="close-button" mat-icon-button (click)="fecharDialog()">
        <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
</div>

<form class="flex flex-col  p-8 pb-0  rounded overflow-hidden" [formGroup]="formulario">

    <div class="flex">
        <mat-form-field class="flex-auto">
            <input matInput formControlName="nova_senha" [placeholder]="'Nova senha'" autocomplete="off">
            <mat-icon matPrefix [svgIcon]="'lock'"></mat-icon>
        </mat-form-field>
    </div>

    <div class="flex">
        <mat-form-field class="flex-auto">
            <input matInput formControlName="nova_senha_dois" [placeholder]="'Repita a nova senha'" autocomplete="off">
            <mat-icon matPrefix [svgIcon]="'lock'"></mat-icon>
        </mat-form-field>
    </div>

</form>

<div class="botoes">
    <!-- Discard -->
    <button mat-button class="mr-2 cancelar" mat-button (click)="fecharDialog()">
        <span>Cancelar</span>
    </button>

    <!-- Save as draft -->
    <button mat-flat-button [disabled]="!span" (click)="salvar(formulario)" class="ml-2 green-600" mat-button>

        <span *ngIf="span">Salvar</span>
        <mat-progress-spinner color="black" *ngIf="!span" [diameter]="24" [mode]="'indeterminate'">
        </mat-progress-spinner>
    </button>

</div>
